/**
 * Travões de custo das APIs pagas usadas no BROWSER (Parte H.4).
 *
 * O orçamento do servidor (`places-cost-guard.server`) impõe limites às
 * chamadas do servidor; o browser não tem orçamento imposto — tem kill
 * switch e feature flags, com carregamento adiado. Os contadores do browser
 * são apenas telemetria, nunca autoridade de limite.
 *
 * Fail-safe: por defeito ligado (a app tem de funcionar); desligar é uma
 * decisão explícita por variável de ambiente pública.
 */

const off = (value: string | undefined): boolean => {
  const raw = (value ?? "").trim().toLowerCase();
  return raw === "0" || raw === "off" || raw === "false";
};

type PublicEnv = Record<string, string | undefined>;

const publicEnv = (): PublicEnv =>
  (typeof import.meta !== "undefined" ? (import.meta.env as unknown as PublicEnv) : {}) ?? {};

/** Mapas interativos do browser (Maps JS SDK — SKU por carregamento de mapa). */
export function mapsEnabled(env: PublicEnv = publicEnv()): boolean {
  return !off(env["VITE_MAPS_ENABLED"]);
}

/** Autocomplete de locais no browser (SKU por sessão/pedido). */
export function autocompleteEnabled(env: PublicEnv = publicEnv()): boolean {
  return !off(env["VITE_AUTOCOMPLETE_ENABLED"]);
}

/** Espera mínima entre teclas antes de gastar uma chamada de autocomplete. */
export const AUTOCOMPLETE_DEBOUNCE_MS = 250;
